import React, { Component, Fragment } from 'react';
import FormInputNumber from '../../../_shared/forms/FormInputNumber';
import DatePicker from 'react-datepicker';
import FormError from '../../../_shared/forms/FormError';
import { SearchableSelect } from '../../../_shared/forms/FormMultiSelect';

export default class OperativeDetails extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Fragment>
                <div className="row pb-3">
                    <div className="col-12">
                        <h6 className="py-2 pl-2 cw-bg-grey text-white">Operative details</h6>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <div className="form-group">
                            <SearchableSelect
                                label="first operative"
                                name="first_operative"
                                options={this.props.operatives}
                                handleChange={(e) => this.props.handleSearchableSelectChange(e, 'first_operative')}
                                value={this.props.first_operative}
                                error={this.props.errors.first_operative}
                            />
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}
